import React from 'react';
import styled from 'styled-components';
import Text from '../../Text';
import Image from '../../Image';

const StyledBaseCard = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 12px;
  background-color: ${({ theme }) => theme.colors.gray200};
  border-radius: ${({ small }) => (small ? '4px' : '6px')};
  padding: ${({ small }) => (small ? '10px 16px' : '12px 16px')};
  :first-of-type {
    margin-top: 0;
  }
`;

const Title = styled(Text)`
  overflow: hidden;
`;

const StyledImage = styled(Image)`
  cursor: pointer;
  height: 18px;
  max-width: 18px;
  flex-shrink: 0;
  flex: 1;
  margin: auto 0px auto 16px;
`;

const ListCard = ({ children, icon, action, actionId, small, color, ...props }) => (
  <StyledBaseCard small={small} {...props}>
    <Title type="Body-2-w500" color="gray700">
      {children}
    </Title>
    <StyledImage id={actionId} onClick={action} src={icon} />
  </StyledBaseCard>
);

export default ListCard;
